import { render, staticRenderFns } from "./LegendSelector.vue?vue&type=template&id=13da76d9&scoped=true"
import script from "./LegendSelector.vue?vue&type=script&lang=js"
export * from "./LegendSelector.vue?vue&type=script&lang=js"
import style0 from "./LegendSelector.vue?vue&type=style&index=0&id=13da76d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da76d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13da76d9')) {
      api.createRecord('13da76d9', component.options)
    } else {
      api.reload('13da76d9', component.options)
    }
    module.hot.accept("./LegendSelector.vue?vue&type=template&id=13da76d9&scoped=true", function () {
      api.rerender('13da76d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/LegendSelector.vue"
export default component.exports